module.exports = __webpack_public_path__ + "img/small.0d3dc6f9.jpg";